module.exports = __webpack_public_path__ + "static/img/04942500.bceb3f82.png";